import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const ChannelWiseBlacklist = lazy(
  () => import('../components/ChannelWiseBlacklist')
);

const channelWiseBlacklist: RouteObject = {
  path: '/settings/blacklist-management/channels',
  element: <ChannelWiseBlacklist />,
};

export default channelWiseBlacklist;
